import gql from 'graphql-tag'

export const GET_ACTUAL_SHIFT_USER_GROUPS_QUERY = gql`
  query GetActualShiftUserGroups {
    getActualShiftUserGroups {
        group
    }
  }
`
